import React from 'react';

import './icons.scss';

const iconsList = [
    {
        title: 'Przypomnienia o fizjoterapii',
        desc: 'Dzięki funkcji ustawiania przypomnień już nigdy nie zapomnisz o wykonaniu ćwiczeń oddechowych!',
        icon: require('../../assets/images/reminder_ico.svg'),
    },
    {
        title: 'Odznaki i poziomy',
        desc: 'Korzystaj aktywnie z aplikacji, aby zdobywać kolejne poziomy i dywizje. Zostań gwiazdą!',
        icon: require('../../assets/images/badge_ico.svg'),
    },
    {
        title: 'Kwestionariusz przed wizytą',
        desc: 'Odpowiedz na kilka pytań przed wizytą lekarską, ułatwisz w ten sposób pracę swojemu lekarzowi.',
        icon: require('../../assets/images/doctor_ico.svg'),
    },
    {
        title: 'Test Fuchsa',
        desc: 'Zdobywaj dodatkowe punkty wykonując cotygodniowy test Fuchsa i monitoruj przebieg swojej choroby.',
        icon: require('../../assets/images/test_ico.svg'),
    },
    {
        title: 'Anonimowość',
        desc: 'Aplikacja nie wymaga od Ciebie podawania żadnych wrażliwych danych.',
        icon: require('../../assets/images/safety_ico.svg'),
    },
]

const Icons = () => {
    return (
        <section className="icons" id="icons">
            <div className="container">
                <h2 className="g-h2" data-aos="fade-up">Dlaczego warto?</h2>
                <ul className="icons__list">
                    {
                        iconsList.map((item, index) => {
                            const {title,desc,icon} = item;
                            return (
                                <li key={title}>
                                    <div className="icons__icon" data-aos="zoom-in">
                                        <img src={icon} alt={title} />
                                    </div>
                                    <div className="icons__text">
                                        <p className="icons__title" data-aos="fade-up" data-aos-delay={index*150}>{title}</p>
                                        <p className="icons__desc" data-aos="fade-up" data-aos-delay={index*250}>{desc}</p>
                                    </div>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        </section>
    )
}
export default Icons;